import { defineMessages } from 'react-intl';

export default defineMessages({
  name: 'Category Name',
  path: 'Category ID Path',
  success: 'Category deleted',
  title: 'Delete Category'
});
